import * as ACTION_TYPES from './Types';

const initialState = {
  categories:{},
  message: '',
  error: null,
}

export const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case ACTION_TYPES.GETCATEGORY_SUCCESS:  
      return {
          ...state,
          categories:action.payload.data,
          message: action.payload.message,
      }

    case ACTION_TYPES.GETCATEGORY_ERROR:    
      return {
        ...state,
        message: action.payload.message,
      } 
    case ACTION_TYPES.ADDCATEGORY_SUCCESS:
    case ACTION_TYPES.UPDATECATEGORY_SUCCESS:  
    case ACTION_TYPES.CHANGEACTION_SUCCESS:
      return {
          ...state,
          categories:action.payload.data,
          message: action.payload.message,
      }

    case ACTION_TYPES.ADDCATEGORY_ERROR:
    case ACTION_TYPES.UPDATECATEGORY_ERROR:
    case ACTION_TYPES.CHANGEACTION_ERROR:   
      return {
        ...state,
        message: action.payload.message,
      }               
        
    default:
      return state;
  }
}
